import { useNavigate } from "react-router-dom";
import "../css/catgridmobile.css";
import { useEffect, useState } from "react";
import { supabase } from "../lib/supabaseClient.ts";

const CategoryGridMobile = () => {
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchCategories() {
      const { data, error } = await supabase
        .from("categories")
        .select("*")
        .gte("id", 80)
        .lte("id", 87)
        .order("id");

      if (error) {
        console.error("Error fetching categories:", error);
      } else {
        setCategories(data);
      }
    }
    fetchCategories();
  }, []);

  return (
    <div className="mobile-scroll-wrapper">
      {categories.map((category) => (
        <div
          key={category.id}
          className="mobile-card"
          style={{ backgroundImage: `url(${category.image})` }}
          onClick={() =>
            navigate(`/category/${category.id}/${encodeURIComponent(category.name)}`)
          }
        >
          <div className="mobile-card-overlay">
            <p className="mobile-card-title">{category.name}</p>
            <div className="mobile-voir-plus">
              {/* <img
                src="../figmaAssets/btn.png"
                alt=""
                className="mobile-voir-plus-img"
              /> */}
              {/* <span className="mobile-voir-plus-text">Voir plus</span> */}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CategoryGridMobile;